import CreatorFormationPage from "./CreatorFormationPage";

export default CreatorFormationPage;